import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface CompanyState {
  /** ISO 4217 code from `getCompanyBasicInfo.company.currencyCode` */
  currencyCode: string | null;
  /** Company legal/display name from `getCompanyBasicInfo.company.name` */
  companyName: string | null;
}

export const initialCompanyState: CompanyState = {
  currencyCode: null,
  companyName: null
};

export const companySlice = createSlice({
  name: "company",
  initialState: initialCompanyState,
  reducers: {
    setCompanyCurrencyCode: (state, action: PayloadAction<string | null>) => {
      state.currencyCode = action.payload;
    },
    setCompanyBasicInfo: (
      state,
      action: PayloadAction<{ currencyCode: string; name: string }>
    ) => {
      state.currencyCode = action.payload.currencyCode;
      state.companyName = action.payload.name;
    }
  }
});

export const { setCompanyCurrencyCode, setCompanyBasicInfo } =
  companySlice.actions;

export default companySlice.reducer;
